import { render, staticRenderFns } from "./MaterialFieldDisplayEdit.vue?vue&type=template&id=cf47d9b8&scoped=true&"
import script from "./MaterialFieldDisplayEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialFieldDisplayEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialFieldDisplayEdit.vue?vue&type=style&index=0&id=cf47d9b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf47d9b8",
  null
  
)

export default component.exports